<template>
  <div class="page-home">
    <!--    <van-floating-bubble icon="chat" @click="handleGoToHistory('/history')">-->
    <!--      <template #default>-->
    <!--        <div class="custom-content" style="display: flex; justify-content: center; align-content: center">-->
    <!--          <img src="@/static/icon_history.svg" width="20"-->
    <!--               height="21" alt=""/>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--    </van-floating-bubble>-->
    <div class="metfone-header">
      <div id="icon-history">
        <div style="display: flex; justify-content: center">
          <!--        <img src="@/static/icon_history_home.png" width="15"-->
          <!--             height="15" alt=""/>-->
          <!--        <van-icon name="user-o" color="#005D85" size="16" />-->
          <div
            v-if="getfullName"
            style="
              font-size: 13px;
              margin-left: 4px;
              color: #005d85;
              text-decoration-color: #005d85 !important;
              text-transform: capitalize;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div style="margin-right: 4px">
              {{ $t("welcome") }},
              <span style="font-weight: 600">
                {{ getfullName }}
              </span>
            </div>
            <!--          <div style="font-weight: 600" class="fullname-container"> Nguyen Tuan Kiet</div>-->
          </div>
          <div
            v-else
            style="
              font-size: 13px;
              margin-left: 4px;
              color: #005d85;
              text-decoration-color: #005d85 !important;
              text-transform: capitalize;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div style="margin-right: 4px">
              {{ $t("welcome") }},
              <span style="font-weight: 600"> Steven Nguyen </span>
            </div>
            <!--          <div style="font-weight: 600" class="fullname-container"> Nguyen Tuan Kiet</div>-->
          </div>
          <!--        <div v-if="getfullName" style="font-size: 13px; margin-left: 4px; color: #005D85; text-decoration-color: #005D85 !important; text-transform: capitalize; display: flex">-->
          <!--        <span  style="margin-right: 4px">{{$t("welcome")}},</span>  <span style="font-weight: 600" class="fullname-container">{{getfullName}}</span> </div>-->
        </div>
        <!--      <div style="display: flex; justify-content: center; align-items: center">-->
        <!--        <img src="@/static/icon_history_home.png" width="15"-->
        <!--             height="15" alt=""/>-->
        <!--        <a @click="handleGoToHistory('/history')" style="font-size: 15px; margin-left: 4px; color: #005D85; text-decoration-color: #005D85 !important; text-decoration-line: underline;">-->
        <!--          {{ $t('history')}}</a>-->
        <!--      </div>-->
      </div>
      <van-tabs
        id="parentElement"
        class="metfone-tab"
        :background="color_primary()"
        color="#fff"
        v-model:active="activeName"
        type="card"
        :sticky="false"
        @change="handleTabChange"
      >
        <van-tab name="mobileServices">
          <template #title>
            <div class="metfone-tab-header-1">
              {{ $t("mobile_services") }}
            </div>
          </template>
        </van-tab>
        <van-tab name="buyMetfoneEsim">
          <template #title>
            <div class="metfone-tab-header">
              {{ $t("metfone_esim") }}
            </div>
          </template>
        </van-tab>
        <!--tab TV360-->
        <!--
        <van-tab name="tabTV360">
          <template #title>
            <div class="metfone-tab-header">
              {{ $t("tv360.title_tab") }}
            </div>
          </template>
        </van-tab>
        -->
      </van-tabs>
    </div>

    <div class="metfone-tab-content">
      <div v-if="activeName == 'mobileServices'">
        <template v-if="isShowContentMobileServices === 'home'">
          <template v-if="loadingService">
            <metfone-loading />
          </template>
          <template
            v-else-if="
              metfoneServices &&
              metfoneServices.length > 0 &&
              checkArray(metfoneServices)
            "
          >
            <div
              v-for="(value, index) in metfoneServices"
              :key="index"
              style="margin-bottom: 10px"
            >
              <PostMetfoneService
                :package_active="itemActive"
                type="home"
                :data="value"
                :show-renew="false"
                @click="handleShowDetail(true, value)"
              />
            </div>
          </template>
          <template
            v-else-if="
              metfoneServices &&
              !checkArray(metfoneServices) &&
              !isObjectEmpty(metfoneServices)
            "
          >
            <div style="margin-bottom: 10px">
              <PostMetfoneService
                type="home"
                :data="metfoneServices"
                :show-renew="false"
                @click="handleShowDetail(true, metfoneServices)"
              />
            </div>
          </template>
          <template v-else>
            <data-notify :content="$t('not_services')" />
          </template>

          <ConfirmPurchase
            :item="item"
            id="postservice"
            v-model:is-show.sync="showDetail"
            v-if="showDetail"
          />
        </template>

        <template v-else>
          <template v-if="packageHistoryLoading">
            <metfone-loading />
          </template>
          <template v-else-if="checkArray(packageHistory) && packageHistory.length > 0">
            <div
              v-for="(value, index) in packageHistory"
              :key="index"
              style="margin-bottom: 10px"
            >
              <PostMetfoneService
                type="history"
                :data="value"
                :show-expired="true"
                :show-status="true"
                @click="handleShowPackageHistoryDetail(true, value)"
              />
            </div>
          </template>
          <template v-else>
            <data-notify :content="$t('not_histories')" />
          </template>
        </template>

        <van-popup
          v-model:show="showCenter"
          round
          :style="{ padding: '0px', width: '80vw', maxWidth: '300px', top: '40vh' }"
          position="center"
        >
          <div v-if="detailModel && detailModel.name">
            <div style="background-color: #005d85">
              <div
                class="popup-header"
                :style="{ backgroundImage: `url(${imageUrl})` }"
              >
                <h6
                  style="margin: 0px; text-align: center; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 16px; padding: 0px 24px;"
                >
                  {{ detailModel.name }}
                </h6>
                <van-button
                  class="btn-closed-detail-package"
                  @click="handleShowPackageHistoryDetail(false, null)"
                  size="24"
                >
                  <img
                    src="@/assets/images/icon-closed-header.png"
                    width="16"
                    height="16"
                  />
                </van-button>
              </div>
            </div>

            <div class="popup-body">
              <h5
                v-if="detailModel.type == 'history'"
                style="margin: 5px 0px; font-weight: 600; font-size: 14px"
              >
                {{ $t("Package Information") }}
              </h5>

              <div class="detail-card-description" v-if="detailModel.fullDes">
                <div v-html="detailModel.fullDes"></div>
              </div>
            </div>
          </div>
        </van-popup>
      </div>

      <van-popup
        v-model:show="showChangeToEsimPopup"
        round
        position="center"
        :close-on-popstate="true"
        :style="{ width: '80vw', maxWidth: '320px', overflow: 'visible' }"
        @closed="onChangeToEsimPopupClosed"
      >
        <div style="padding: 24px; text-align: center;">
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 12px;">
            {{ $t("notice") }}
          </div>
          <div style="font-size: 14px; color: #333; margin-bottom: 24px; line-height: 1.5;">
            {{ $t("feature_coming_soon") }}
          </div>
          <button
            type="button"
            class="esim-action-card__btn"
            @click="showChangeToEsimPopup = false">
            {{ $t("esim_ok") }}
          </button>
        </div>
      </van-popup>

      <div
        v-if="activeName == 'buyMetfoneEsim'"
        class="metfone-tab-content__buy-esim"
      >
        <Devices v-model:isShowDevices="isShowDevices" :devices="devices" />
        <div v-if="isShowMyOrder == 'buyEsim'">
          
          <div class="esim-menu-header">
            <button
              type="button"
              class="esim-supported-devices"
              @click="isShowDevices = true"
            >
              <span>{{ $t("esim_supported_devices") }}</span>
              <van-icon name="question" color="#005D85" size="16" />
            </button>
          </div>

          <div class="esim-action-card">
            <div class="esim-action-card__content">
              <div class="esim-action-card__title">
                {{ $t("esim_buy_new_card_title") }}
              </div>
              <div class="esim-action-card__desc">
                {{ $t("esim_buy_new_card_desc") }}
              </div>
              <button
                type="button"
                class="esim-action-card__btn"
                @click="handleOpenBuyNewEsim"
              >
                {{ $t("esim_buy_new_card_title") }}
              </button>
            </div>
          </div>

          <div class="esim-action-card">
            <div class="esim-action-card__content">
              <div class="esim-action-card__title">
                {{ $t("esim_change_to_esim_card_title") }}
              </div>
              <div class="esim-action-card__desc">
                {{ $t("esim_change_to_esim_card_desc") }}
              </div>
              <button
                type="button"
                class="esim-action-card__btn"
                @click="handleOpenChangeToEsim"
              >
                {{ $t("esim_change_to_esim_card_title") }}
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <MyOrder />
          <div class="version-code">{{ $t("version") }} {{ versionCode }}</div>
        </div>

        <!-- <ConfirmPurchase :item="item" id="postservice" v-model:is-show.sync="showDetail" v-if="showDetail" /> -->
        <!-- <div class="internet-wifi">
          <img src="@/static/icon-empty-internet-wifi.svg" />
          <p class="internet-wifi__description">
            {{ $t("internet_wifi_dev") }}
          </p>
        </div> -->
      </div>

      <!--tabTV360 tab content-->
      <div v-if="activeName == 'tabTV360'" class="metfone-tab-content__tv360">
        <TV360Home />
      </div>
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style src="./index.css" lang="css" scoped></style>
